import React from 'react';
import Icon from 'components/icon/icon'

const DropZoneIndicator = () => {
    return (
        <div className="drop-zone-indicator">
            <div>
                <Icon name="fe-upload" />
                <span>
                    Release to upload
                </span>
            </div>
        </div>
    )
};

export default DropZoneIndicator;



// WEBPACK FOOTER //
// ./src/components/drop-zone-indicator/drop-zone-indicator.jsx